import React from 'react';

const Twitter = () => (
	<svg viewBox="0 0 48 48" className="icon twitter">
		<path d="M34.59,16.69a6.22,6.22,0,0,0-.54-.82l.87-4.41a.38.38,0,0,0-.55-.4L30.9,13a5.91,5.91,0,0,0-3-.84,6,6,0,0,0-6,6c0,.1,0,.2,0,.3A13.17,13.17,0,0,1,15.47,13a.37.37,0,0,0-.66.07,17.71,17.71,0,0,0-1.26,5,13.2,13.2,0,0,0,2.89,8.26A13,13,0,0,1,10.59,24a.38.38,0,0,0-.59.34,13.12,13.12,0,1,0,24.59-7.68Z"/>
  </svg>
);

export default Twitter;



// WEBPACK FOOTER //
// ./src/components/Icons/Twitter.js